<template>
  <div class="deliverable-departments" v-if="deliverable">
    <div class="pb-0 titles exclude-outside-click" v-show="!addDepartmentFlag" @click="showAddDepartment">
      <div
        class="department-title exclude-outside-click"
        v-for="(department, index) in deliverable.departments"
        :key="'deliverable-modal-department-'+department.id"
      >
        <span style="color: #2D3135" v-if="index > 0">&nbsp;&</span> {{ department.name }}
      </div>
      <div class="department-title exclude-outside-click" v-show="!hasDepartments()">No Department</div>
      <plus-button class="tagged-departments"/>
    </div>
    <multiselect
      ref="deliverableDepartments"
      v-click-outside="outside"
      v-show="addDepartmentFlag"
      v-model="deliverable.departments"
      :close-on-select="true"
      :options="allActiveDepartments"
      :show-labels="false"
      :multiple="true"
      :taggable="false"
      label="name"
      track-by="id"
      :id="deliverable.deliverableId"
      @input="updateFieldValue(deliverable)"
      @close="addDepartmentFlag=false"
    ></multiselect>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["deliverable"],
  data() {
    return {
      addDepartmentFlag: false
    };
  },
  computed: {
    ...mapGetters(["allDepartments", "allActiveDepartments", "userAbilities"]),
  },
  methods: {
    ...mapActions(["updateFieldValue"]),
    hasDepartments() {
      if (this.deliverable) {
        if (this.deliverable.departments) {
          if (this.deliverable.departments.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    showAddDepartment() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addDepartmentFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableDepartments.$el.focus()
      })
    },
    outside() {
      this.$set(this, "addDepartmentFlag", false);
    }
  }
};
</script>

<style>
</style>